export default __webpack_public_path__ + "static/2-5dabd17b535d0c84cd399257759e3556.png";